// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2506":"b46f07ad","4827":"b46f07ad","6377":"1077cc13","9246":"b46f07ad","9629":"1077cc13"}[chunkId] + ".chunk.css";
};